export enum PositionTypes {
  Long = "L",
  Short = "S",
}
